/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var storageKey = 'evo:wishlist:v1';
  var drawer = document.querySelector('[data-evo-wishlist-drawer]');
  var itemsContainer = document.querySelector('[data-evo-wishlist-items]');
  var emptyState = document.querySelector('[data-evo-wishlist-empty]');
  var drawerCount = document.querySelector('[data-evo-wishlist-drawer-count]');
  var countBadges = document.querySelectorAll('[data-evo-wishlist-count]');
  var translationsNode = document.querySelector('[data-evo-wishlist-translations]');
  var translations = {};

  if (!drawer || !itemsContainer || !emptyState || !translationsNode) {
    return;
  }

  try {
    translations = JSON.parse(translationsNode.textContent || '{}');
  } catch (error) {
    translations = {};
  }

  function getItems() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function saveItems(items) {
    window.localStorage.setItem(storageKey, JSON.stringify(items));
  }

  function countLabel(count) {
    return (translations.count || '999999 produse').replace('999999', String(count));
  }

  function productLabel(key, title) {
    return (translations[key] || '').replace('[[title]]', title || '');
  }

  function updateCounts(items) {
    var count = items.length;

    if (drawerCount) {
      drawerCount.textContent = countLabel(count);
    }

    countBadges.forEach(function (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  }

  function findItem(items, handle) {
    return items.find(function (item) {
      return item.handle === handle;
    });
  }

  function updateButtons(items) {
    document.querySelectorAll('[data-evo-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var title = button.getAttribute('data-product-title') || '';
      var active = Boolean(findItem(items, handle));

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', productLabel(active ? 'removeProduct' : 'addProduct', title));
    });
  }

  function createImage(item) {
    if (!item.image) {
      var placeholder = document.createElement('div');
      placeholder.className = 'evo-wishlist-item__placeholder';
      return placeholder;
    }

    var image = document.createElement('img');
    image.className = 'evo-wishlist-item__image';
    image.src = item.image;
    image.alt = item.title || '';
    image.loading = 'lazy';
    return image;
  }

  function renderItems() {
    var items = getItems();
    updateCounts(items);
    updateButtons(items);
    itemsContainer.textContent = '';
    emptyState.classList.toggle('is-visible', items.length === 0);

    items.forEach(function (item) {
      var row = document.createElement('article');
      row.className = 'evo-wishlist-item';
      row.appendChild(createImage(item));

      var content = document.createElement('div');
      content.className = 'evo-wishlist-item__content';

      var title = document.createElement('a');
      title.className = 'evo-wishlist-item__title';
      title.href = item.url || '#';
      title.textContent = item.title || '';
      content.appendChild(title);

      var actions = document.createElement('div');
      actions.className = 'evo-wishlist-item__actions';

      var addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'evo-wishlist-item__add';
      addButton.textContent = item.available === false ? translations.soldOut : translations.addToCart;
      addButton.disabled = item.available === false || !item.variantId;
      addButton.setAttribute('data-evo-wishlist-add', item.variantId || '');
      actions.appendChild(addButton);

      var removeButton = document.createElement('button');
      removeButton.type = 'button';
      removeButton.className = 'evo-wishlist-item__remove';
      removeButton.textContent = translations.remove || 'Remove';
      removeButton.setAttribute('data-evo-wishlist-remove', item.handle || '');
      actions.appendChild(removeButton);

      content.appendChild(actions);
      row.appendChild(content);
      itemsContainer.appendChild(row);
    });
  }

  function openDrawer() {
    renderItems();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    var panel = drawer.querySelector('.evo-wishlist-drawer__panel');
    if (panel) {
      panel.focus();
    }
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function productFromButton(button) {
    return {
      handle: button.getAttribute('data-product-handle'),
      title: button.getAttribute('data-product-title'),
      url: button.getAttribute('data-product-url'),
      image: button.getAttribute('data-product-image'),
      variantId: button.getAttribute('data-product-variant-id'),
      available: button.getAttribute('data-product-available') === 'true'
    };
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-evo-wishlist-open]');
    var closeButton = event.target.closest('[data-evo-wishlist-close]');
    var toggleButton = event.target.closest('[data-evo-wishlist-toggle]');
    var removeButton = event.target.closest('[data-evo-wishlist-remove]');
    var addButton = event.target.closest('[data-evo-wishlist-add]');

    if (openButton) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (closeButton) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();

      var items = getItems();
      var product = productFromButton(toggleButton);

      if (!product.handle) {
        return;
      }

      if (findItem(items, product.handle)) {
        items = items.filter(function (item) {
          return item.handle !== product.handle;
        });
      } else {
        items.unshift(product);
      }

      saveItems(items);
      renderItems();
      return;
    }

    if (removeButton) {
      event.preventDefault();
      var handle = removeButton.getAttribute('data-evo-wishlist-remove');
      saveItems(getItems().filter(function (item) {
        return item.handle !== handle;
      }));
      renderItems();
      return;
    }

    if (addButton) {
      event.preventDefault();

      if (addButton.disabled) {
        return;
      }

      fetch(window.routes.cartAddUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(addButton.getAttribute('data-evo-wishlist-add')),
          quantity: 1
        })
      }).then(function () {
        addButton.textContent = translations.added || translations.addToCart;
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: 1 }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }).catch(function () {
        window.location.href = window.routes.cartUrl;
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  renderItems();
})();

(function () {
  function moveProductBenefits() {
    var slot = document.querySelector('.evo-product-benefits-slot');
    var badgeContainer = document.querySelector('.deco-trust-badge-container[deco-data-trust-badge-id="2910"]');

    if (!slot || !badgeContainer) {
      return;
    }

    var badge = badgeContainer.closest('.deco-trust-badge');

    if (badge && !slot.contains(badge)) {
      slot.appendChild(badge);
    }
  }

  document.addEventListener('DOMContentLoaded', moveProductBenefits);
  window.addEventListener('load', moveProductBenefits);
  setTimeout(moveProductBenefits, 1200);
  setTimeout(moveProductBenefits, 2600);

  if (document.body) {
    var observer = new MutationObserver(moveProductBenefits);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

(function () {
  function getModal() {
    return document.querySelector('[data-evo-return-modal]');
  }

  function getDialog() {
    var modal = getModal();
    return modal ? modal.querySelector('[data-evo-return-dialog]') : null;
  }

  function getForm() {
    var modal = getModal();
    return modal ? modal.querySelector('#evo-return-form') : null;
  }

  function setPageLock(locked) {
    document.documentElement.classList.toggle('evo-return-open', locked);

    if (document.body) {
      document.body.classList.toggle('evo-return-open', locked);
    }
  }

  function openModal() {
    var modal = getModal();
    var dialog = getDialog();

    if (!modal) {
      return;
    }

    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    setPageLock(true);

    if (dialog) {
      window.setTimeout(function () {
        dialog.focus();
      }, 20);
    }
  }

  function closeModal() {
    var modal = getModal();

    if (!modal) {
      return;
    }

    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    setPageLock(false);
  }

  function fieldValue(form, name) {
    if (!form || !form.elements || !form.elements[name]) {
      return '';
    }

    var field = form.elements[name];

    if (field.length && typeof field !== 'string' && field[0] && field[0].type === 'radio') {
      for (var i = 0; i < field.length; i += 1) {
        if (field[i].checked) {
          return field[i].value;
        }
      }

      return '';
    }

    if (field.type === 'radio') {
      return field.checked ? field.value : '';
    }

    return field.value || '';
  }

  function serializeForm(form) {
    return {
      name: fieldValue(form, 'contact[name]'),
      phone: fieldValue(form, 'contact[phone]'),
      email: fieldValue(form, 'contact[email]'),
      companyCode: fieldValue(form, 'contact[CUI]'),
      tradeRegister: fieldValue(form, 'contact[Nr Registrul Comertului]'),
      companyAddress: fieldValue(form, 'contact[Sediu social]'),
      address: fieldValue(form, 'contact[Adresa]'),
      product: fieldValue(form, 'contact[Produs achizitionat]'),
      orderDate: fieldValue(form, 'contact[Comandat la data]'),
      deliveryDate: fieldValue(form, 'contact[Primit la data]'),
      orderNumber: fieldValue(form, 'contact[Numar comanda]'),
      paymentMethod: fieldValue(form, 'contact[Achitat cu]'),
      paymentDetails: fieldValue(form, 'contact[Detalii plata]'),
      reason: fieldValue(form, 'contact[Motivul returnarii]'),
      requestType: fieldValue(form, 'contact[Solicitare]'),
      bank: fieldValue(form, 'contact[Banca]'),
      bankAccount: fieldValue(form, 'contact[Cont bancar]'),
      accountHolder: fieldValue(form, 'contact[Titular cont]'),
      bankAddress: fieldValue(form, 'contact[Adresa titular]'),
      sourcePage: fieldValue(form, 'contact[Pagina de trimitere]')
    };
  }

  function updateFilledState(input) {
    if (!input || !input.classList || input.type === 'hidden') {
      return;
    }

    if (input.value) {
      input.classList.add('is-filled');
    } else {
      input.classList.remove('is-filled');
    }
  }

  function restoreFormState(form, state) {
    if (!form || !state) {
      return;
    }

    Array.prototype.forEach.call(form.elements, function (element) {
      if (!element.name || !Object.prototype.hasOwnProperty.call(state, element.name)) {
        return;
      }

      if (element.type === 'radio') {
        element.checked = state[element.name] === element.value;
        return;
      }

      if (element.name === 'contact[body]') {
        return;
      }

      element.value = state[element.name];
      updateFilledState(element);

      if (element.parentElement && element.parentElement.classList.contains('select-wrapper')) {
        if (element.value) {
          element.parentElement.classList.add('is-filled');
        } else {
          element.parentElement.classList.remove('is-filled');
        }
      }
    });
  }

  function snapshotFormState(form) {
    var state = {};

    Array.prototype.forEach.call(form.elements, function (element) {
      if (!element.name) {
        return;
      }

      if (element.type === 'radio') {
        if (element.checked) {
          state[element.name] = element.value;
        }

        return;
      }

      state[element.name] = element.value;
    });

    return state;
  }

  function buildMessage(state) {
    var rows = [
      ['Cerere retur produs', ''],
      ['Nume client / firma', state.name],
      ['Telefon', state.phone],
      ['E-mail', state.email],
      ['CUI', state.companyCode],
      ['Nr Registrul Comertului', state.tradeRegister],
      ['Sediu social', state.companyAddress],
      ['Adresa', state.address],
      ['Produs achizitionat', state.product],
      ['Comandat la data', state.orderDate],
      ['Primit la data', state.deliveryDate],
      ['Numar comanda', state.orderNumber],
      ['Achitat cu', state.paymentMethod],
      ['Detalii plata', state.paymentDetails],
      ['Motivul returnarii', state.reason],
      ['Solicitare', state.requestType],
      ['Banca', state.bank],
      ['Cont / IBAN', state.bankAccount],
      ['Titular cont', state.accountHolder],
      ['Adresa titular', state.bankAddress],
      ['Pagina de trimitere', state.sourcePage]
    ];
    var lines = [];

    rows.forEach(function (row) {
      if (row[0] && !row[1]) {
        lines.push(row[0]);
        return;
      }

      if (row[0] && row[1]) {
        lines.push(row[0] + ': ' + row[1]);
      }
    });

    return lines.join('\n');
  }

  function syncHiddenBody(form) {
    var bodyField = form.querySelector('[data-evo-return-body]');

    if (!bodyField) {
      return;
    }

    bodyField.value = buildMessage(serializeForm(form));
  }

  async function submitReturnForm(form) {
    var submitButton = form.querySelector('[data-evo-return-submit]');
    var previousLabel = submitButton ? submitButton.textContent : '';
    var savedState = snapshotFormState(form);

    syncHiddenBody(form);

    if (submitButton) {
      submitButton.classList.add('is-submitting');
      submitButton.textContent = 'Se trimite...';
    }

    try {
      var response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nextModal = doc.querySelector('[data-evo-return-modal]');
      var currentModal = getModal();

      if (!nextModal || !currentModal) {
        form.submit();
        return;
      }

      currentModal.innerHTML = nextModal.innerHTML;
      openModal();

      var nextForm = getForm();

      if (nextForm && nextForm.querySelector('[data-evo-return-form-state]')) {
        var stateNode = nextForm.querySelector('[data-evo-return-form-state]');

        if (stateNode.getAttribute('data-evo-return-form-state') === 'error') {
          restoreFormState(nextForm, savedState);
          syncHiddenBody(nextForm);
        }
      }

      var dialog = getDialog();

      if (dialog) {
        dialog.scrollTop = 0;
      }
    } catch (error) {
      form.submit();
      return;
    } finally {
      var refreshedSubmitButton = getForm() ? getForm().querySelector('[data-evo-return-submit]') : null;

      if (submitButton) {
        submitButton.classList.remove('is-submitting');
        submitButton.textContent = previousLabel || 'Send';
      }

      if (refreshedSubmitButton) {
        refreshedSubmitButton.classList.remove('is-submitting');
      }
    }
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-evo-return-open]');
    var closeTrigger = event.target.closest('[data-evo-return-close]');

    if (openTrigger) {
      event.preventDefault();
      openModal();
      return;
    }

    if (closeTrigger) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('#evo-return-form');

    if (!form) {
      return;
    }

    event.preventDefault();
    submitReturnForm(form);
  });

  document.addEventListener('input', function (event) {
    var form = getForm();

    if (!form || !form.contains(event.target)) {
      return;
    }

    updateFilledState(event.target);
    syncHiddenBody(form);
  });

  document.addEventListener('change', function (event) {
    var form = getForm();

    if (!form || !form.contains(event.target)) {
      return;
    }

    if (event.target.parentElement && event.target.parentElement.classList.contains('select-wrapper')) {
      if (event.target.value) {
        event.target.parentElement.classList.add('is-filled');
      } else {
        event.target.parentElement.classList.remove('is-filled');
      }
    }

    syncHiddenBody(form);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var form = getForm();
    var stateNode = form ? form.querySelector('[data-evo-return-form-state]') : null;

    if (!form || !stateNode) {
      return;
    }

    syncHiddenBody(form);

    if (stateNode.getAttribute('data-evo-return-form-state') !== 'idle') {
      openModal();
    }
  });
})();
